import * as moment from 'moment';
import { momentDateFormat } from './formatting';

export const getTodaysDateString = (): string => moment().format(momentDateFormat);

export const iOSDownloadLink =
    'https://itunes.apple.com/gb/app/tour-24-self-guided-apt-tour/id1462185580?mt=8';
export const androidDownloadLink =
    'https://play.google.com/store/apps/details?id=com.toursphere.tour24';

export const partition = <T>(array: T[], predicate: (elem: T) => boolean) => {
    return array.reduce(
        ([whereTrue, whereFalse], elem) => {
            return predicate(elem)
                ? [[...whereTrue, elem], whereFalse]
                : [whereTrue, [...whereFalse, elem]];
        },
        [[], []]
    );
};

export const buildGoogleMapQuery = (
    address: string,
    city?: string,
    state?: string,
    zip?: string
): string => {
    let googleBaseUrl = 'https://www.google.com/maps/search/?api=1&query=';
    //Filter out any parameters that are falsy
    let queryString = encodeURI([address, city, state, zip].filter(Boolean).join(', '));
    return googleBaseUrl + queryString;
};

export const intersperse = <T>(array: T[], seperator: T) =>
    array.length === 0
        ? []
        : array
              .slice(1)
              .reduce(
                  (accumulator: T[], currentElement: T, currentIndex: number) => [
                      ...accumulator,
                      seperator,
                      currentElement
                  ],
                  [array[0]]
              );

export const formatPhoneNumber = (
    numericString: string | undefined,
    isInternationalNumber?: boolean
) => {
    if (numericString === undefined || numericString === null) {
        return '';
    }

    return isInternationalNumber
        ? numericString.replace(/(\d{3})(\d{3,})/, '$1 $2')
        : numericString.slice(0, 2) === '+1'
        ? numericString.replace(/(.{2})(\d{3})(\d{3})(\d{4})/, '$1 $2-$3-$4')
        : numericString.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
};

export const unformatPhoneNumber = (phoneNumber: string | undefined) => {
    if (phoneNumber === undefined || phoneNumber === null) {
        return '';
    }

    return phoneNumber.replace(/\D/g, '');
};

export const getNumberOfDaysInMonth = (month: number) => {
    let longMonths = [1, 3, 5, 7, 8, 10, 12];
    let shortMonths = [4, 6, 9, 11];

    if (longMonths.indexOf(month) !== -1) {
        return '31';
    } else if (shortMonths.indexOf(month) !== -1) {
        return '30';
    } else {
        return '29';
    }
};

export const monthOptions = [
    { value: 1, label: 'January' },
    { value: 2, label: 'February' },
    { value: 3, label: 'March' },
    { value: 4, label: 'April' },
    { value: 5, label: 'May' },
    { value: 6, label: 'June' },
    { value: 7, label: 'July' },
    { value: 8, label: 'August' },
    { value: 9, label: 'September' },
    { value: 10, label: 'October' },
    { value: 11, label: 'November' },
    { value: 12, label: 'December' }
];

export const isCreditCardExpired = (startOfExpirationMonth: string) =>
    moment(startOfExpirationMonth).add(1, 'month').isBefore();



// WEBPACK FOOTER //
// ./src/utilities/Utils.ts